import { Component, Input } from '@angular/core';
import { Financial } from '../../../models/financial.model';
import { CommonModule } from '@angular/common';
import { ScrollerModule } from 'primeng/scroller';
import { TreeTableModule } from 'primeng/treetable';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'app-list-financial-history',
  standalone: true,
  imports: [CommonModule, ScrollerModule, TreeTableModule],
  templateUrl: './list-financial-history.component.html'
})
export class ListFinancialHistoryComponent {
  cols = [
    { field: 'name', header: 'Nome' },
    { field: 'type', header: 'Tipo' }
  ];

  @Input() customerId!: number;
  @Input() customerName!: string;

  nodes: TreeNode[] = [];

  ngOnInit(): void {
    this.nodes = Array.from({ length: 50 }).map((_, i) => ({
      key: `node-${i}`,
      data: {
        name: `Item ${i + 1}`,
        type: 'Root'
      },
      leaf: false  // Não adicione `children` aqui!
    }));
  }

  loadNodesLazy(event: any) {
    const node = event.node;

    if (node && !node.children) {
      setTimeout(() => {
        node.children = Array.from({ length: 5 }).map((_, i) => ({
          key: `${node.key}-child-${i}`,
          data: {
            name: `Filho ${i + 1} de ${node.data.name}`,
            type: 'Child'
          },
          leaf: true
        }));
      }, 500);
    }
  }
}